import {
  Box,
  Typography,
  Grid,
  Stack,
  IconButton,
  Collapse,
} from "@mui/material";
import { colors } from "../../theme/theme";
import {
  MoreVertOutlined,
  NoteOutlined,
  ReplyOutlined,
  ShareOutlined,
} from "@mui/icons-material";
import { CustomBtn } from "../Common/CustomBtn";
import { discussionDetailData } from "../../assets/data";
import { useEffect, useState } from "react";
import DiscussionItem from "../Groups/DiscussionItem";
import CustomModal from "../Common/CustomModal";
import axiosInstance from "../../utils/config/config";
import { useSelector } from "react-redux";

const GroupDetailModal = ({ open, onClose, groupId, joinGroup }) => {
  const { userData } = useSelector((state) => state.user);
  const [moreReplies, setMoreReplies] = useState(false);

  const [groupData, setGroupData] = useState(null);

  const getGroupById = async () => {
    try {
      const response = await axiosInstance.get(
        `/group/getOneGroup?id=${groupId}`
      );

      if (response.status === 200) {
        setGroupData(response.data?.group);
        console.log("Get Group By Id");
      }
    } catch (error) {
      console.error("Error fetching group data:", error);
    }
  };

  useEffect(() => {
    if (groupId) {
      getGroupById();
    }
  }, [groupId]);

  return (
    <CustomModal open={open} onClose={onClose} title="Group Details">
      {/* Cover Image */}
      <img
        src={groupData?.image_url}
        alt="cover"
        style={{
          height: "150px",
          width: "100%",
          objectFit: "cover",
          borderRadius: "14px",
        }}
      />

      <Grid container spacing={2}>
        <Grid
          item
          size={{ xs: 12, sm: 5 }}
          sx={{
            borderRight: "1px solid rgba(0,0,0,0.1)",
            pt: 1,
            pr: 1,
          }}
        >
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography
              sx={{
                color: colors.primary,
                fontSize: "24px",
                fontFamily: "Mulish-Bold",
              }}
            >
              {groupData?.title}
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton>
                <ShareOutlined sx={{ fontSize: 20, color: colors.primary }} />
              </IconButton>
              <IconButton>
                <MoreVertOutlined
                  sx={{ fontSize: 20, color: colors.primary }}
                />
              </IconButton>
            </Stack>
          </Stack>
          <Stack direction={"row"} spacing={1} mt={1}>
            <NoteOutlined sx={{ fontSize: 20, color: colors.secondary }} />
            <Typography
              sx={{
                color: colors.primary,
                fontSize: "14px",
                fontFamily: "Mulish-Medium",
              }}
            >
              {groupData?.description}
            </Typography>
          </Stack>

          <Box>
            {/* Moderators */}
            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "Mulish-Bold",
                fontSize: "14px",
                mt: 2,
              }}
            >
              Moderators (2)
            </Typography>
            <Stack
              direction={"row"}
              spacing={1}
              mt={1}
              sx={{ borderBottom: "1px solid rgba(0,0,0,0.1)", pb: 1 }}
            >
              <img
                src={require("../../assets/images/discussion1.png")}
                alt="moderator"
                style={{
                  height: "35px",
                  width: "35px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <Stack direction={"column"}>
                <Typography
                  sx={{
                    color: colors.primary,
                    fontSize: "13px",
                    fontFamily: "Mulish-Medium",
                  }}
                >
                  William Marshal
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(25,34,52,0.5)",
                    fontSize: "13px",
                    fontFamily: "Mulish-Medium",
                  }}
                >
                  Maastricht, Limburg, Netherlands
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction={"row"}
              spacing={1}
              mt={1}
              sx={{ borderBottom: "1px solid rgba(0,0,0,0.1)", pb: 1 }}
            >
              <img
                src={require("../../assets/images/discussion2.png")}
                alt="moderator"
                style={{
                  height: "35px",
                  width: "35px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <Stack direction={"column"}>
                <Typography
                  sx={{
                    color: colors.primary,
                    fontSize: "13px",
                    fontFamily: "Mulish-Medium",
                  }}
                >
                  John Doe
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(25,34,52,0.5)",
                    fontSize: "13px",
                    fontFamily: "Mulish-Medium",
                  }}
                >
                  Amsterdam, Netherlands
                </Typography>
              </Stack>
            </Stack>

            {/* Group Members */}
            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "Mulish-Bold",
                fontSize: "14px",
                mt: 2,
                mb: 1,
              }}
            >
              Group Members (20)
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <img
                src={require("../../assets/images/discussion1.png")}
                alt="member"
                style={{
                  height: "35px",
                  width: "35px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <img
                src={require("../../assets/images/discussion2.png")}
                alt="member"
                style={{
                  height: "35px",
                  width: "35px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <img
                src={require("../../assets/images/discussion3.png")}
                alt="member"
                style={{
                  height: "35px",
                  width: "35px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </Box>

            {/* Join Btn */}
            <CustomBtn
              text="Join this Group (Get 14 pts)"
              width="100%"
              height="40px"
              fontSize="14px"
              icon
              mt={4}
              onClick={() => joinGroup(userData?.id, groupId)}
            />
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, sm: 7 }} sx={{ pt: 1.5 }}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "Mulish-Bold",
                fontSize: "20px",
              }}
            >
              Discussions
            </Typography>
            <Typography
              sx={{
                color: colors.secondary,
                fontFamily: "Mulish-Medium",
                fontSize: "14px",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              Join this group to start a new discussion.
            </Typography>
          </Stack>

          {discussionDetailData.map((item, index) => (
            <DiscussionItem key={index} item={item} index={index}>
              <Collapse in={moreReplies} timeout="auto" unmountOnExit>
                {item.replies.map((reply, replyIndex) => (
                  <DiscussionItem
                    item={reply}
                    index={replyIndex}
                    key={replyIndex}
                  />
                ))}
              </Collapse>

              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={0.5}
                mt={1}
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => setMoreReplies(!moreReplies)}
              >
                <Typography
                  sx={{
                    color: colors.secondary,
                    fontSize: "12px",
                    fontFamily: "Mulish-Regular",
                    textDecoration: "underline",
                  }}
                >
                  {moreReplies ? "hide 5 replies" : "more 5 replies"}
                </Typography>
                <ReplyOutlined sx={{ fontSize: 20, color: colors.secondary }} />
              </Stack>
            </DiscussionItem>
          ))}
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default GroupDetailModal;
